//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'UsuarioToolbar',
  props: {
    usuario: String,
    mail: String,
    estruturaUsuario: String,
    perfil: String,
  },
  data: () => ({
    menu: false,
    message: false,
    hints: true,
  }),
  computed: {
    ...mapGetters('controlador', [
      'getControladores',
      'getControladoreSelecionado',
    ]),
    controladores() {
      return this.getControladores || [];
    },
    temControladores() {
      return !!this.controladores.length;
    },
    exibirControladores() {
      // Issue 258: Está criando controlador com funcionario titular
      // quando o usuario não tem divisão
      // Após editar o funcionário com divisão, acabava ficando com dois controladores
      // Essa funcionalidade será revisada no estágio 3
      return this.temControladores &&
        (this.controladores.length > 1 ||
          (this.controladores.length === 1 && !!this.controladores[0].idDivisaoTitular));
    },
  },
  methods: {
    ...mapActions('controlador', [
      'setControladoreSelecionado',
    ]),
    itemSelecionado(item) {
      return item.id === this.getControladoreSelecionado.id;
    },
    selecionar(item) {
      if (this.itemSelecionado(item)) return;
      this.setControladoreSelecionado(item);
      this.menu = false;
      this.$emit('UsuarioToolBar_selecionar', item);
    },
    logout() {
      this.menu = false;
      const auth = this.$auth || window.auth;
      auth.logout();
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/shared-components/toolbar/UsuarioToolbar.vue?vue&type=script&lang=js&